/* Repeater rows for the "participants" form field type */

// Renumber the visible "Participant N" headings and hide the remove button when
// only one row is left, so the field can never be emptied out entirely.
function refresh(container) {
  const rows = container.querySelectorAll('[data-wps-participant-row]');
  rows.forEach((row, index) => {
    const number = row.querySelector('[data-wps-participant-number]');
    if (number) number.textContent = String(index + 1);

    const remove = row.querySelector('[data-wps-participant-remove]');
    if (remove) remove.classList.toggle('hidden', rows.length <= 1);
  });
}

function addRow(container) {
  const template = container.querySelector('[data-wps-participants-template]');
  const rows = container.querySelector('[data-wps-participants-rows]');
  if (!template || !rows) return;

  const row = template.content.firstElementChild.cloneNode(true);
  rows.appendChild(row);
  refresh(container);

  const firstInput = row.querySelector('input');
  if (firstInput) firstInput.focus();
}

// Delegated listener — attached once at module load, so it survives Turbo
// navigations and works for rows added after the initial render.
document.addEventListener('click', (event) => {
  const add = event.target.closest('[data-wps-participants-add]');
  if (add) {
    const container = add.closest('[data-wps-participants]');
    if (container) {
      event.preventDefault();
      addRow(container);
    }
    return;
  }

  const remove = event.target.closest('[data-wps-participant-remove]');
  if (!remove) return;

  const container = remove.closest('[data-wps-participants]');
  const row = remove.closest('[data-wps-participant-row]');
  if (!container || !row) return;

  event.preventDefault();
  if (container.querySelectorAll('[data-wps-participant-row]').length <= 1) return;

  row.remove();
  refresh(container);
});

export function initFormParticipants() {
  document.querySelectorAll('[data-wps-participants]').forEach(refresh);
}
